import { render, staticRenderFns } from "./upload-deposit-reciep.vue?vue&type=template&id=3530b436&"
import script from "./upload-deposit-reciep.vue?vue&type=script&lang=js&"
export * from "./upload-deposit-reciep.vue?vue&type=script&lang=js&"
import style0 from "./upload-deposit-reciep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "upload-deposit-reciep.vue"
export default component.exports